<template>
  <b-container v-if="type && models" fluid>
    <page-title icon="fas fa-file-alt">
      <translate v-if="id">Shipment Order Edit</translate>
      <translate v-else-if="cloneId">Clone Shipment Order</translate>
      <translate v-else>New Shipment Order</translate>
    </page-title>

    <api-item-edit type="shippingOrders" :clone="!!cloneId" :static-item="cloneId && Object.keys(staticItem.item).length > 0 ? staticItem : null" :model="models.shippingOrders" :id="id" />

  </b-container>
</template>

<script>
import ApiItemEdit from '@/components/ApiLists/ApiItemEdit'

export default {
  name: 'ShippingOrderEdit',
  title() {
    if (this.id) {
      return this.$gettext('Shipment Order Edit')
    } else if (this.clone) {
      return this.$gettext('Clone Shipment Order')
    } else {
      return this.$gettext('New Shipment Order')
    }
  },
  components: {
    ApiItemEdit
  },
  props: {
    type: {
      type: String,
      default: 'shippingOrders'
    },
    id: {
      type: [Number, String],
      default: null
    },
    cloneId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      model: null,
      item: {},
      staticItem: {
        item: {}
      }
    }
  },
  created () {
    this.model = this.models.shippingOrders
  },
  mounted() {
    if (this.cloneId) {
      this.getItem()
    }
  },
  methods: {
    async getItem() {
      const params = {}
      if (this.model.includes) {
        params.includes = this.model.includes
      }
      await this.$http.get(this.model.endpoint + '/' + this.cloneId, { params })
        .then(response => {
          this.item = response.body
          this.item.status = 'draft'
          delete this.item.id
          delete this.item.external_id
          delete this.shippings
          this.setDateTimeParts()
          this.staticItem.item = this.item
        })
    },
    setDateTimeParts() {
      for (const field of this.model.fields) {
        if (field.type === 'datetime' || field.type === 'date') {
          if (this.model.countrize || this.model.countrizeById) {
            this.$tz = window.countries.find(x => x.iso_code === this.item[this.model.countrize] || x.id === this.item[this.model.countrizeById]).front_config.i18n.tz
            this.moment.tz.setDefault(this.$tz)
            const watchCountryKey = 'item.' + (this.model.countrize || this.model.countrizeById)
            this.$watch(
              watchCountryKey,
              (val) => {
                this.$tz = window.countries.find(x => x.iso_code === val || x.id === val).front_config.i18n.tz
                this.moment.tz.setDefault(this.$tz)
              },
              {
                immediate: true
              }
            )
          }
          this.item[field.key + 'DateTimeParts'] = []
          this.item[field.key + 'DateTimeParts'][0] = this.moment.utc(this.item[field.key]).tz(this.$tz).format('YYYY-MM-DD')
          this.item[field.key + 'DateTimeParts'][1] = field.type !== 'date' ? this.moment.utc(this.item[field.key]).tz(this.$tz).format('HH:mm:ss') : '00:00:00'
        }
      }
      console.log(this.item)
    }
  }
}
</script>
